"use strict";

/**
 * FAQ Subject Selector - AJAX Handler
 * Integrates with existing _faqs.js behavior
 */
jQuery(document).ready(function ($) {
  /**
   * Handle FAQ Subject Selector clicks
   */
  $('.faqs-subject-selector__label').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var subjectId = $this.data('subject');
    var targetId = $this.data('target');

    // Don't reload if already active
    if ($this.hasClass('active')) {
      return;
    }

    // Update active state
    $this.closest('ul').find('.faqs-subject-selector__label').removeClass('active');
    $this.addClass('active');

    // Find target FAQ container
    var $targetContainer = $('#' + targetId);
    if (!$targetContainer.length) {
      console.error('FAQ target container not found:', targetId);
      return;
    }

    // Close any open FAQs before loading new ones
    $targetContainer.find('.faqs__item').trigger('blur');

    // Add loading state
    $targetContainer.addClass('faqs--loading');
    $targetContainer.html('<li class="faqs__loading-message">Loading FAQs...</li>');

    // Make AJAX request
    $.ajax({
      url: faqsAjax.ajaxurl,
      type: 'POST',
      data: {
        action: 'load_faqs_by_subject',
        nonce: faqsAjax.nonce,
        subject_id: subjectId
      },
      success: function success(response) {
        if (response.success && response.data.html) {
          // Replace FAQ content
          $targetContainer.html(response.data.html);

          // Re-initialize FAQ interactions (from _faqs.js)
          initializeFaqInteractions($targetContainer);
        } else {
          // Show error message
          $targetContainer.html('<li class="faqs__error-message">' + (response.data.message || 'No FAQs found for this subject.') + '</li>');
        }
      },
      error: function error(xhr, status, _error) {
        console.error('AJAX Error:', _error);
        $targetContainer.html('<li class="faqs__error-message">An error occurred while loading FAQs. Please try again.</li>');
      },
      complete: function complete() {
        $targetContainer.removeClass('faqs--loading');
      }
    });
  });

  /**
   * Initialize FAQ interactions (matches behavior from _faqs.js)
   * This is called after AJAX loads new FAQs
   */
  function initializeFaqInteractions($container) {
    var $scope = $container || $(document);

    // Arrow click handler
    $scope.find('.faqs__arrow').off('click.faqArrow').on('click.faqArrow', function () {
      var faqItem = $(this).closest('.faqs__item');
      if (faqItem.is(':focus')) {
        faqItem.trigger('blur');
      }
    });

    // Prevent default on answer links
    $scope.find('.faqs__answer a').off('mousedown.faqLink').on('mousedown.faqLink', function (e) {
      e.preventDefault();
    });

    // Close button handler
    $scope.find('.faqs__close').off('click.faqClose').on('click.faqClose', function () {
      var faqItem = $(this).closest('.faqs__item');
      if (faqItem.is(':focus')) {
        faqItem.trigger('blur');
        // Scroll into view if supported
        if (faqItem.get(0).scrollIntoViewIfNeeded) {
          faqItem.get(0).scrollIntoViewIfNeeded({
            behavior: 'smooth'
          });
        } else {
          // Fallback for browsers that don't support scrollIntoViewIfNeeded
          faqItem.get(0).scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }
    });
  }

  // Initialize FAQ interactions on page load
  initializeFaqInteractions();

  /**
   * Auto-load first subject on page load if selector exists
   * This happens after the page is fully loaded
   */
  $(window).on('load', function () {
    $('.faqs-subject-selector').each(function () {
      var $firstSubject = $(this).find('.faqs-subject-selector__label.active').first();
      if ($firstSubject.length) {
        // Small delay to ensure everything is ready
        setTimeout(function () {
          $firstSubject.trigger('click');
        }, 100);
      }
    });
  });
});